 import Typography from "@mui/material/Typography";
import BreadCrumb from "../Components/BreadCrumbs";
import InputLabel from "@mui/material/InputLabel";
import DateInput from "../Components/DateInput";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormLabel,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Box from "@mui/material/Box";
import * as React from "react";
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";

import {
  _addBatchModes,
  _addBatches,
  getBatchModes,
  getBatches,
  _deleteBatchMode,
  _deleteBatches,
  _updateBatchMode,
  _updateBatches,
  getAllCourses,
  httpGet,
} from "../Services/api-services";
import CustomizedSnackbars from "../Components/Snackbar";
import { getCourses } from "../Services/api-services";
import Autocomplete from "@mui/material/Autocomplete";
import DynamicTable from "../Components/DynamicTable";
import DialogueBox from "../Components/DialogueBox";
import moment from "moment";
import Panel from "../Components/Panel";
import NodataInTable from "../Components/NoDataInTable";
import DateSearchFilter from "../Components/DateSearchFilter";
import { letterSpacing } from "@mui/system";
import CONSTANTS from "../constant.json";
import { UserAuthState } from "../Services/RecoilService";
import { useRecoilState } from "recoil";
import { updateLocalStorage } from "../Services/services";
import DateRangePicker from "../Components/DateRangePiker";

function Batch() {
  const [batchModeDataSource, setBatchModeDataSource] = React.useState(null);
  const [batchM, setBatchM] = React.useState([]);
  const [batchesDataSource, setBatchesDataSource] = React.useState(null);
  const [allBatches, setAllBatches] = React.useState([]);
  const [allBatchModes, setAllBatchModes] = React.useState([]);
  const [batchModeDialog, setBatchModeDialog] = React.useState(false);
  const [batchesDialog, setBatchesDialog] = React.useState(false);
  const [updateBatchMode, setUpdateBatchMode] = React.useState(false);
  const [updateBatches, setUpdateBatches] = React.useState(false);
  const [batchModeName, setBatchModeName] = React.useState("");
  const [batchModeIndex, setBatchModeIndex] = React.useState("");
  const [batchesIndex, setBatchesIndex] = React.useState("");
  const [selectCourse, setSelectCourse] = React.useState("");
  const [selectCourseData, setSelectCourseData] = React.useState("");
  const [allCourses, setAllCourses] = React.useState([]);
  const [batchName, setBatchName] = React.useState("");
  const [date, setDate] = React.useState("");
  const [timeFrom, setTimeFrom] = React.useState("");
  const [timeTo, setTimeTo] = React.useState("");
  const [courseId, setCourseId] = React.useState("");
  const [addbatchMode, setAddBatchMode] = React.useState(false);
  const [addBatches, setAddBatches] = React.useState(false);
  const [confirmDialog, setConfirmDialog] = React.useState(false);

  const [startDate, setStartDate] = React.useState(null);
  const [endDate, setEndDate] = React.useState(null);
  const [authState, setAuthState] = useRecoilState(UserAuthState);
  const [isLoading, setIsLoading] = React.useState(false);
  const [input, setInputSearch] = React.useState("");

  // Add a debounce timer for search
  const [searchTimer, setSearchTimer] = React.useState(null);

  const [snackBarOptions, setSnackBarOptions] = React.useState({
    message: "",
    duration: 5000,
    show: false,
    severity: "",
  });

  // Debounced search effect
  React.useEffect(() => {
    if (searchTimer) {
      clearTimeout(searchTimer);
    }

    const newTimer = setTimeout(() => {
      if (input !== undefined) {
        handleSearch();
      }
    }, 500); // 500ms delay

    setSearchTimer(newTimer);

    return () => {
      if (newTimer) {
        clearTimeout(newTimer);
      }
    };
  }, [input]);

  const handleSearch = () => {
    const filterData = {
      input: input || "",
    };

    // Include dates if both are set or both are null
    const bothDatesSet = startDate && endDate;
    const bothDatesNull = !startDate && !endDate;
    
    if (bothDatesSet) {
      filterData.startDate = startDate;
      filterData.endDate = endDate;
    }

    fetchBatches(filterData);
    fetchBatchMode(filterData);
  };

  React.useEffect(() => {
    const modules = authState?.userData?.assignModules?.assignModule;
    const batchArr = modules.find((m) => m?.name === "Batchs");
    setBatchM(batchArr);
    
    let data = {
      startDate: startDate,
      endDate: endDate,
      input: "",
    };

    async function fetchData(data) {
      try {
        const data = {
          startDate: startDate,
          endDate: endDate,
          input: input,
        };
        if ((startDate && endDate) || (!startDate && !endDate)) {
          data.startDate = startDate;
          data.endDate = endDate;
        }

        if ((startDate && endDate) || (!startDate && !endDate)) {
          const courses = await getAllCourses(data);
          setAllCourses(courses);
          const batchModes = await getBatchModes(data);
          if (batchModes?.error?.statusCode === 401) {
            updateLocalStorage();
          }
          setAllBatchModes(batchModes);
          const _dataSourceBatchMode = await createTableDataBatchMode(
            batchModes
          );
          setBatchModeDataSource(_dataSourceBatchMode);
          const batches = await getBatches(data);
          setAllBatches(batches);
          if (batches?.error?.statusCode === 401) {
            updateLocalStorage();
          }
          const _dataSourceBatches = await createTableDataBatches(batches);
          setBatchesDataSource(_dataSourceBatches);
        }
      } catch (err) {
        console.log(err);
      }
    }
    fetchData(data);
    // eslint-disable-next-line
  }, []);

  const batch = [
    <Typography component={"div"} sx={{ fontSize: "20px" }} key="1">
      Master
    </Typography>,
    <Typography component={"div"} sx={{ fontSize: "20px" }} key="2">
      Batch
    </Typography>,
  ];

  // BATCH MODE FLOW

  function openBatchModeDialog() {
    setBatchModeDialog(true);
  }

  function closeBatchModeDialog() {
    setUpdateBatchMode(false);
    setBatchModeDialog(false);
    setBatchModeName("");
    setAddBatchMode(false);
  }
  function clearAddBatchForm() {
    setBatchName("");
    setSelectCourse("");
    setDate("");
    setTimeFrom("");
    setTimeTo("");
    setAddBatches(false);
    setSelectCourseData("");
  }

  const fetchBatchMode = async (data) => {
    let _batchMode;
    let filterData;

    if (data === undefined || data === null) {
      filterData = {
        input: input || "", // Use current search input
      };
      if (startDate) filterData.startDate = startDate;
      if (endDate) filterData.endDate = endDate;
    } else {
      filterData = { ...data };
      if (!filterData.startDate || filterData.startDate === null) {
        delete filterData.startDate;
      }
      if (!filterData.endDate || filterData.endDate === null) {
        delete filterData.endDate;
      }
    }

    setIsLoading(true);
    try {
      _batchMode = await getBatchModes(filterData);
      if (_batchMode?.error?.statusCode === 401) {
        updateLocalStorage();
      }

      setAllBatchModes(_batchMode);
      const _dataSource = await createTableDataBatchMode(_batchMode);
      setBatchModeDataSource(_dataSource);
    } catch (error) {
      console.error("Error fetching batch modes:", error);
      setSnackBarOptions({
        message: "Failed to fetch batch modes!",
        show: true,
        severity: "error",
        duration: 5000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  async function duplicateBatchMode() {
    let url = `${CONSTANTS.baseUrl}/batchModes?filter={"where":{"name":{"regexp":"/${batchModeName}/i"},"deleted":false}}`;
    const req = await httpGet(url);
    return req.length > 0 ? false : true;
  }

  async function addNewBatchMode() {
    if (!(await duplicateBatchMode())) {
      setSnackBarOptions({
        message: "Duplicate Batch Mode!",
        show: true,
        severity: "error",
        duration: 5000,
      });
      closeBatchModeDialog();
      return;
    }
    if (batchModeName) {
      setAddBatchMode(true);
      const body = {
        name: batchModeName,
        status: true,
      };
      try {
        const response = await _addBatchModes(body);
        const _bmFilter = { 
          startDate, 
          endDate: endDate,
          input: input || "" // Include current search
        };
        fetchBatchMode(_bmFilter);
        setSnackBarOptions({
          message: "Batch Mode added successfully!",
          show: true,
          severity: "success",
          duration: 5000,
        });
        closeBatchModeDialog();
      } catch (error) {
        console.log(error);
      }
    } else {
      setAddBatchMode(true);
    }
  }

  function editBatchModeDialog(e, data) {
    setBatchModeIndex(data.id);
    setUpdateBatchMode(true);
    setBatchModeDialog(true);
    setBatchModeName(data.name);
  }

  async function updateBatchModes() {
    setIsLoading(true);
    try {
      const body = {
        name: batchModeName,
        id: batchModeIndex,
      };

      const response = await _updateBatchMode(body, batchModeIndex);

      const filterData = {
        input: input || "", // Include current search
      };

      if (startDate) filterData.startDate = startDate;
      if (endDate) filterData.endDate = endDate;

      await fetchBatchMode(filterData);

      setSnackBarOptions({
        message: "Batch Mode updated successfully!",
        show: true,
        severity: "success",
        duration: 5000,
      });

      closeBatchModeDialog();
    } catch (error) {
      console.error("Error updating batch mode:", error);
      setSnackBarOptions({
        message: "Failed to update batch mode!",
        show: true,
        severity: "error",
        duration: 5000,
      });
    } finally {
      setIsLoading(false);
    }
  }

  async function updateBatch() {
    setIsLoading(true);
    const body = {
      name: batchName,
      startDate: date,
      from: timeFrom,
      to: timeTo,
      courseId: courseId,
      id: batchesIndex,
      status: true,
    };
    const response = await _updateBatches(body, batchesIndex);
    setIsLoading(false);
    
    // Include current search in refresh
    const filterData = {
      input: input || "",
    };
    if (startDate) filterData.startDate = startDate;
    if (endDate) filterData.endDate = endDate;
    
    fetchBatches(filterData);
    closeBatchesDialog();
  }

  function _openConfirmDialogBatchMode(e, data) {
    setBatchModeIndex(data.id);
    setConfirmDialog(true);
  }

  async function deleteBatchMode() {
    const body = {
      deleted: true,
      status: false,
    };
    const response = await _deleteBatchMode(body, batchModeIndex).then(
      (res) => {
        // Include current search in refresh
        const filterData = {
          input: input || "",
        };
        if (startDate) filterData.startDate = startDate;
        if (endDate) filterData.endDate = endDate;
        fetchBatchMode(filterData);
      }
    );
    setConfirmDialog(false);
  }

  // BATCHES FLOW

  function openBatchesDialog() {
    setBatchesDialog(true);
  }

  function closeBatchesDialog() {
    setBatchesDialog(false);
    setUpdateBatches(false);
    clearAddBatchForm();
  }

  const fetchBatches = async (data = null) => {
    let _batches;
    let filterData;

    if (data === null || data === undefined) {
      filterData = {
        input: input || "", // Use current search input
      };
      if (startDate) filterData.startDate = startDate;
      if (endDate) filterData.endDate = endDate;
    } else {
      filterData = { ...data };
      if (!filterData.startDate || filterData.startDate === null) {
        delete filterData.startDate;
      }
      if (!filterData.endDate || filterData.endDate === null) {
        delete filterData.endDate;
      }
    }

    setIsLoading(true);
    try {
      _batches = await getBatches(filterData);
      if (_batches?.error?.statusCode === 401) {
        updateLocalStorage();
      }

      setAllBatches(_batches);
      const _dataSource = await createTableDataBatches(_batches);
      setBatchesDataSource(_dataSource);
    } catch (error) {
      console.error("Error fetching batches:", error);
    } finally {
      setIsLoading(false);
    }
  };

  async function addBatch() {
    setIsLoading(true);
    if (batchName && selectCourse && date && timeFrom && timeTo) {
      const body = {
        name: batchName,
        from: timeFrom,
        to: timeTo,
        courseId: courseId,
        status: true,
        startDate: date,
      };
      try {
        const response = await _addBatches(body);
        setIsLoading(false);
        
        // Include current search in refresh
        const filterData = {
          input: input || "",
        };
        if (startDate) filterData.startDate = startDate;
        if (endDate) filterData.endDate = endDate;
        
        fetchBatches(filterData);
        setBatchesDialog(false);
        setSnackBarOptions({
          message: "Batch added successfully!",
          show: true,
          severity: "success",
          duration: 5000,
        });
        clearAddBatchForm();
      } catch (error) {
        console.log(error);
        setIsLoading(false);
      }
    } else {
      setAddBatches(true);
      setIsLoading(false);
    }
  }

  const fetchBatchById = (batches, _id) => {
    return new Promise((resolve, reject) => {
      for (let index = 0; index < batches.length; index++) {
        const _batch = batches[index];
        if (_id === _batch.id) {
          resolve(_batch);
          break;
        }
      }
    });
  };

  async function editBatchesDialog(e, data) {
    setBatchesIndex(data.id);
    data = await fetchBatchById(allBatches, data.id);
    const course = await fetchBatchById(allCourses, data.courseId);
    setSelectCourseData(course);
    setCourseId(data.courseId);
    setUpdateBatches(true);
    setSelectCourse(data.courseId);
    setUpdateBatches(true);
    setBatchesDialog(true);
    setBatchName(data.name);

    const formattedDate = moment(data.startDate).format("YYYY-MM-DD");
    setDate(formattedDate);

    setTimeFrom(data.from);
    setTimeTo(data.to);
  }

  function _openConfirmDialogBatches(e, data) {
    setBatchesIndex(data.id);
    setConfirmDialog(true);
  }

  async function deleteBatches() {
    const body = {
      deleted: true,
      status: false,
    };
    const response = await _deleteBatches(body, batchesIndex).then((res) => {
      // Include current search in refresh
      const filterData = {
        input: input || "",
      };
      if (startDate) filterData.startDate = startDate;
      if (endDate) filterData.endDate = endDate;
      fetchBatches(filterData);
    });
    setConfirmDialog(false);
  }

  function updateTime(e, type) {
    const time = e.target.value ? e.target.value.split(":") : [];

    if (type === "from") {
      if (timeTo) {
        const _to = timeTo.split(":");
        if (parseInt(time[0]) > parseInt(_to[0])) {
          setSnackBarOptions({
            message: "From time should be less than to time",
            show: true,
            severity: "error",
            duration: 5000,
          });
        } else if (parseInt(time[0]) === parseInt(_to[0])) {
          if (parseInt(time[1]) > parseInt(_to[1])) {
            setSnackBarOptions({
              message: "From time should be less than to time",
              show: true,
              severity: "error",
              duration: 5000,
            });
          } else setTimeFrom(e.target.value);
        } else setTimeFrom(e.target.value);
      } else setTimeFrom(e.target.value);
    } else {
      if (timeFrom) {
        const _from = timeFrom.split(":");
        if (parseInt(time[0]) < parseInt(_from[0])) {
          setSnackBarOptions({
            message: "From time should be less than to time",
            show: true,
            severity: "error",
            duration: 5000,
          });
        } else if (parseInt(time[0]) === parseInt(_from[0])) {
          if (parseInt(time[1]) < parseInt(_from[1])) {
            setSnackBarOptions({
              message: "From time should be less than to time",
              show: true,
              severity: "error",
              duration: 5000,
            });
          } else setTimeTo(e.target.value);
        } else setTimeTo(e.target.value);
      } else setTimeTo(e.target.value);
    }
  }

  const headCellsBatchMode = [
    {
      id: "sno",
      numeric: false,
      disablePadding: false,
      sort: false,
      label: "S.no",
    },
    {
      id: "name",
      numeric: false,
      disablePadding: false,
      sort: true,
      label: "Name",
    },
    {
      id: "createdAt",
      numeric: true,
      disablePadding: false,
      sort: true,
      label: "Created On",
    },
    {
      id: "action",
      numeric: true,
      disablePadding: false,
      sort: false,
      label: "Action",
    },
  ];

  if (batchM?.update !== true) {
    headCellsBatchMode.pop();
  }

  const headCellsBatches = [
    {
      id: "sno",
      numeric: false,
      disablePadding: false,
      sort: false,
      label: "S.no",
    },
    {
      id: "name",
      numeric: false,
      disablePadding: false,
      sort: true,
      label: "Batch Name",
    },
    {
      id: "course",
      numeric: false,
      disablePadding: false,
      sort: true,
      label: "Course",
    },
    {
      id: "batchmode",
      numeric: false,
      disablePadding: false,
      sort: true,
      label: "Batch Mode",
    },
    {
      id: "year",
      numeric: false,
      disablePadding: false,
      sort: true,
      label: "Created on",
    },
    {
      id: "currency",
      numeric: false,
      disablePadding: false,
      sort: true,
      label: "Currency",
    },
    {
      id: "time",
      numeric: true,
      disablePadding: false,
      sort: true,
      label: "Time",
    },
    {
      id: "action",
      numeric: true,
      disablePadding: false,
      sort: false,
      label: "Action",
    },
  ];

  if (batchM?.update !== true) {
    headCellsBatches.pop();
  }

  const createTableDataBatchMode = (data) => {
    let returnArray = [];
    return new Promise((resolve, reject) => {
      if (data && data.length) {
        for (let index = 0; index < data.length; index++) {
          const row = data[index];
          const obj = {
            sno: index + 1,
            id: row.id,
            name: row.name,
            createdAt: row.createdAt,
            action: true,
          };
          returnArray.push(obj);
          if (index === data.length - 1) resolve(returnArray);
        }
      } else resolve([]);
    });
  };

  const createTableDataBatches = (data) => {
    let returnArray = [];
    return new Promise((resolve, reject) => {
      if (data && data.length) {
        for (let index = 0; index < data.length; index++) {
          const row = data[index];
          const obj = {
            courseId: row.courseId,
            sno: index + 1,
            id: row.id,
            course: row.course?.name,
            year: moment(row.startDate).format("MMMM Do YYYY"),
            time: `${row.from}-${row.to}`,
            name: row.name,
            createdAt: row.createdAt,
            action: true,
            batchmode: row?.course?.batchmode?.name,
            currency: row.course?.country?.currencyName,
          };
          if (batchM?.write !== true) {
            delete obj.action;
          }
          returnArray.push(obj);
          if (index === data.length - 1) resolve(returnArray);
        }
      } else resolve([]);
    });
  };

  // Removed the old handleInputDateChange function since it's not being used

  const getDate = (data) => {    
    let newStartDate = data.startDate || null;
    let newEndDate = data.endDate || null;
    
    setStartDate(newStartDate);
    setEndDate(newEndDate);
    
    const bothDatesSet = newStartDate && newEndDate;
    const bothDatesEmpty = !newStartDate && !newEndDate;
    
    if (bothDatesSet || bothDatesEmpty) {
      const filterData = {
        input: input || "",
      };
      
      if (bothDatesSet) {
        filterData.startDate = newStartDate;
        filterData.endDate = newEndDate;
      }
            
      fetchBatches(filterData);
      fetchBatchMode(filterData);
    } else {
      console.log('Skipping API call - only one date is set');
    }
  };

  return (
    <div className="h-full w-full overflow-auto py-4 px-8">
      <div className="flex items-center justify-between">
        <BreadCrumb data={batch} />
        <div className="flex items-center ">
          <FormControl sx={{ width: "300px", marginRight: "10px" }}>
            <TextField
              size="small"
              sx={{ backgroundColor: "white" }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="sm" />
                  </InputAdornment>
                ),
              }}
              id="outlined-basic"
              placeholder="Search"
              variant="outlined"
              value={input}
              onChange={(e) => setInputSearch(e.target.value)}
            />
          </FormControl>
          <DateRangePicker getData={getDate} />
        </div>
      </div>

      <Box className="my-7">
        <Panel
          tabIndex={0}
          labelOne="Batch Modes"
          labelTwo="Batches"
          secondPanel={true}
          tabOne={
            <div>
              {batchModeDataSource === null ? (
                <div className="h-full w-full items-center justify-center flex">
                  <h1 className="h-60 w-60">
                    {" "}
                    <CircularProgress />
                  </h1>
                </div>
              ) : batchModeDataSource?.length > 0 ? (
                <div className="my-6">
                  <DynamicTable
                    dataSource={batchModeDataSource}
                    headCells={headCellsBatchMode}
                    actionOnDelete={(e, data) =>
                      _openConfirmDialogBatchMode(e, data)
                    }
                    actionOnEdit={(e, data) => editBatchModeDialog(e, data)}
                    pagination={true}
                    edit={true}
                    delete={true}
                  />
                  <DialogueBox
                    confirmDialog={confirmDialog}
                    message={"Batch Mode"}
                    confirmDialogClose={() => setConfirmDialog(false)}
                    confirmDelete={deleteBatchMode}
                  />
                </div>
              ) : (
                <NodataInTable message="No batch mode is created yet.To create batch mode click on add icon." />
              )}

              <Dialog fullWidth={true} maxWidth="md" open={batchModeDialog}>
                <DialogTitle>
                  {updateBatchMode === false ? "ADD" : "UPDATE"} BATCH MODE
                </DialogTitle>
                <Divider />
                <DialogContent>
                  <div className="px-7">
                    <FormControl fullWidth>
                      <FormLabel required>Name</FormLabel>

                      <TextField
                        error={
                          addbatchMode && batchModeName.length < 1
                            ? true
                            : false
                        }
                        helperText={
                          addbatchMode && batchModeName.length < 1
                            ? "Batch Mode name cannot be empty"
                            : ""
                        }
                        value={batchModeName}
                        onChange={(e) => setBatchModeName(e.target.value)} // Fixed: Just set the batch mode name
                        required={true}
                        id="outlined-basic"
                        variant="outlined"
                      />
                    </FormControl>
                  </div>
                </DialogContent>
                <Divider />
                <DialogActions>
                  <Button
                    sx={{ marginY: "10px" }}
                    variant="outlined"
                    onClick={closeBatchModeDialog}
                  >
                    Cancel
                  </Button>
                  {updateBatchMode === false ? (
                    <Button
                      sx={{ marginY: "10px" }}
                      variant="contained"
                      onClick={addNewBatchMode}
                    >
                      Add
                    </Button>
                  ) : (
                    <Button
                      onClick={updateBatchModes}
                      sx={{ marginY: "10px" }}
                      variant="contained"
                    >
                      Update
                    </Button>
                  )}
                </DialogActions>
              </Dialog>
              <div>
                <Button
                  disabled={batchM?.write ? false : true}
                  onClick={openBatchModeDialog}
                  variant="contained"
                  sx={{
                    borderRadius: "50px",
                    height: "60px",
                    width: "60px",
                    position: "fixed",
                    bottom: "40px",
                    right: "40px",
                  }}
                >
                  <AddIcon sx={{ fontSize: "30px" }} />
                </Button>
              </div>
            </div>
          }
          tabTwo={
            <div>
              {batchesDataSource === null ? (
                <div className="h-full w-full items-center justify-center flex">
                  <h1 className="h-60 w-60">
                    {" "}
                    <CircularProgress />
                  </h1>
                </div>
              ) : batchesDataSource?.length > 0 ? (
                <div className="my-6">
                  <DynamicTable
                    dataSource={batchesDataSource}
                    headCells={headCellsBatches}
                    actionOnDelete={(e, data) =>
                      _openConfirmDialogBatches(e, data)
                    }
                    actionOnEdit={(e, data) => editBatchesDialog(e, data)}
                    pagination={true}
                    edit={true}
                    delete={true}
                  />
                  <DialogueBox
                    confirmDialog={confirmDialog}
                    message={"Batch"}
                    confirmDialogClose={() => setConfirmDialog(false)}
                    confirmDelete={deleteBatches}
                  />
                </div>
              ) : (
                <NodataInTable message="No batch is created yet.To create batch click on add icon." />
              )}
              <Dialog fullWidth={true} maxWidth="md" open={batchesDialog}>
                <DialogTitle>
                  {updateBatches === false ? "ADD" : "UPDATE"} BATCH
                </DialogTitle>
                <Divider />
                <DialogContent>
                  <div className="px-7 my-7">
                    <FormControl fullWidth>
                      <FormLabel required>Batch Name</FormLabel>

                      <TextField
                        error={
                          addBatches && batchName.length < 1 ? true : false
                        }
                        helperText={
                          addBatches && batchName.length < 1
                            ? "Batch Mode name cannot be empty"
                            : ""
                        }
                        value={batchName}
                        onChange={(e) => setBatchName(e.target.value)}
                        required={true}
                        id="outlined-basic"
                        variant="outlined"
                      />
                    </FormControl>

                    <FormControl sx={{ marginTop: "30px" }} fullWidth>
                      <FormLabel required>Select Course</FormLabel>
                      <Autocomplete
                        value={selectCourseData || null}
                        disablePortal
                        id="combo-box-demo"
                        getOptionLabel={(option) =>
                          `${option?.name} - ${option?.batchmode?.name} - ${option?.country?.currencyName} `
                        }
                        options={allCourses}
                        inputValue={selectCourse}
                        onInputChange={(event, selectCourse) => {
                          setSelectCourse(selectCourse);
                        }}
                        isOptionEqualToValue={(_option, value) => {
                          return true;
                        }}
                        onChange={(event, val) => {
                          setCourseId(val.id);
                          setSelectCourseData(val);
                        }}
                        renderInput={(params) => (
                          <TextField
                            key={params.id.toString()}
                            {...params}
                            error={
                              addBatches && selectCourse.length < 1
                                ? true
                                : false
                            }
                            required={true}
                            helperText={
                              addBatches && selectCourse.length < 1
                                ? "Course cannot be empty"
                                : ""
                            }
                            id="outlined-basic"
                            variant="outlined"
                          />
                        )}
                      />
                    </FormControl>

                    <FormControl sx={{ marginTop: "30px" }} fullWidth>
                      <FormLabel required>DD/MM/YY</FormLabel>
                      <TextField
                        error={addBatches && date.length < 1 ? true : false}
                        helperText={
                          addBatches && date.length < 1
                            ? "Date cannot be empty"
                            : ""
                        }
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                        required={true}
                        type="date"
                        id="outlined-basic"
                        variant="outlined"
                      />
                    </FormControl>
                    <div className="flex">
                      <FormControl sx={{ marginTop: "30px" }} fullWidth>
                        <FormLabel required>Time From</FormLabel>
                        <TextField
                          error={
                            addBatches && timeFrom.length < 1 ? true : false
                          }
                          helperText={
                            addBatches && timeFrom.length < 1
                              ? "Time cannot be empty"
                              : ""
                          }
                          value={timeFrom}
                          onChange={(e) => updateTime(e, "from")}
                          required={true}
                          id="outlined-basic"
                          type="time"
                          variant="outlined"
                        />
                      </FormControl>

                      <FormControl sx={{ marginTop: "30px" }} fullWidth>
                        <FormLabel required>Time To</FormLabel>
                        <TextField
                          error={addBatches && timeTo.length < 1 ? true : false}
                          helperText={
                            addBatches && timeTo.length < 1
                              ? "Time cannot be empty"
                              : ""
                          }
                          value={timeTo}
                          onChange={(e) => updateTime(e, "to")}
                          required={true}
                          type="time"
                          id="outlined-basic"
                          variant="outlined"
                        />
                      </FormControl>
                    </div>
                  </div>
                </DialogContent>
                <Divider />
                <DialogActions>
                  <Button
                    sx={{ marginY: "10px" }}
                    variant="outlined"
                    onClick={closeBatchesDialog}
                  >
                    Cancel
                  </Button>
                  {updateBatches === false ? (
                    <Button
                      onClick={addBatch}
                      disabled={isLoading}
                      sx={{ marginY: "10px" }}
                      variant="contained"
                    >
                      {isLoading ? <CircularProgress size={20} /> : "Add"}
                    </Button>
                  ) : (
                    <Button
                      onClick={updateBatch}
                      disabled={isLoading}
                      sx={{ marginY: "10px" }}
                      variant="contained"
                    >
                      {isLoading ? <CircularProgress size={20} /> : "Update"}
                    </Button>
                  )}
                </DialogActions>
              </Dialog>
              <div>
                <Button
                  onClick={openBatchesDialog}
                  variant="contained"
                  disabled={batchM?.write ? false : true}
                  sx={{
                    borderRadius: "50px",
                    height: "60px",
                    width: "60px",
                    position: "fixed",
                    bottom: "40px",
                    right: "40px",
                  }}
                >
                  <AddIcon sx={{ fontSize: "30px" }} />
                </Button>
              </div>
            </div>
          }
        />
      </Box>
      <CustomizedSnackbars
        message={snackBarOptions.message}
        open={snackBarOptions.show}
        close={() => {
          setSnackBarOptions({ ...snackBarOptions, show: false });
        }}
        hideDur={5000}
        severity={snackBarOptions.severity}
      />
    </div>
  );
}
export default Batch;
